import { observable, action } from "mobx";
import { FieldDescriptors, FieldType } from '../../../util/urlSync';

export const urlQueryDefinition = FieldDescriptors.build({
  userOptions: FieldType.delimitedArrayOf(FieldType.string),
  providers: FieldType.delimitedArrayOf(FieldType.string),
  caption: FieldType.string
});

class MediaFiltersStore {

  userOptions = [
    {
      id: "starred",
      name: "Starred"
    },
    {
      id: "positive",
      name: "Positive"
    },
    {
      id: "negative",
      name: "Negative"
    },
    {
      id: "hasCaption",
      name: "Has Caption"
    },
    {
      id: "userPosted",
      name: "User Posted",
      exclusiveType: "businessPosted"
    },
    {
      id: "businessPosted",
      name: "Business Posted",
      exclusiveType: "businessPosted"
    },
  ];

  @observable state = {
    userOptions: [],
    providers: [],
    isStarred: undefined,
    thumbRating: [],
    businessPosted: undefined,
    hasCaption: undefined,
    caption: undefined
  };

  @action
  setState(updates, callback) {
    Object.assign(this.state, updates);
    callback && callback();
  }
}

const mediaFiltersStore = new MediaFiltersStore();

export default mediaFiltersStore;
